import React from 'react';
import { CustomerPointBreakdownContainerStyled } from './styled';
import { portalService } from 'apiServices';
import { toast } from 'react-toastify';
import { Buttons, Displays } from 'components';
import {
  formatDate,
  formatDateTime,
  formatPoint,
  LEDGER_SIGNED_LABEL,
  LEDGER_SIGNED_POINT,
  RENDER_LEDGER_ACTION,
  RENDER_LOG_STATUS,
  RENDER_LOT_LABEL,
} from 'utils/functions/pointExpire';

// ที่มาที่ไปของแต้มลูกค้า 1 คน: ยอดแยกตามล็อต + รายการเดินแต้ม (ledger) + ประวัติการตัดแต้ม
class CustomerPointBreakdownContainer extends React.Component {
  state = {
    isLoading: true,
    data: null,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { customerId } = this.props;
    let res = await portalService.GET_POINT_EXPIRE_CUSTOMER(customerId);
    if (res && res.status === 200) {
      this.setState({ data: res.data, isLoading: false });
    } else {
      const message =
        (res && res.data && res.data.error && res.data.error.message) ||
        'ไม่พบข้อมูล';
      toast.error(message);
      this.setState({ isLoading: false });
    }
  };

  renderStat = (label, value, className) => (
    <div className={`stat_box ${className || ''}`}>
      <div className="stat_label">{label}</div>
      <div className="stat_value">{value}</div>
    </div>
  );

  render() {
    const { onClose } = this.props;
    const { isLoading, data } = this.state;
    const customer = (data && data.customer) || {};
    const lots = (data && data.lots) || [];
    const ledger = (data && data.ledger) || [];
    const expireLogs = (data && data.expire_logs) || [];
    const nextExpire = data && data.next_expire;

    return (
      <CustomerPointBreakdownContainerStyled>
        <div className="modal_head">
          <div>
            <div className="modal_title">ที่มาที่ไปของแต้ม</div>
            {data && (
              <div className="modal_sub">
                {customer.user_id || '-'} • CU {customer.cu_id || '-'}
                {customer.firstname || customer.lastname
                  ? ` • ${customer.firstname || ''} ${customer.lastname || ''}`
                  : ''}
              </div>
            )}
          </div>
          <div className="close_btn" onClick={onClose}>
            ✕
          </div>
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="300px" />
        ) : !data ? (
          <div className="empty">ไม่พบข้อมูล</div>
        ) : (
          <>
            <div className="stat_row">
              {this.renderStat(
                'ยอดใน wallet',
                data.wallet_point === null ? 'ไม่มี wallet' : formatPoint(data.wallet_point)
              )}
              {this.renderStat('ยอดตาม ledger', formatPoint(data.ledger_balance))}
              {this.renderStat(
                'ยอดตรงกัน',
                data.is_mismatch ? 'ไม่ตรง' : 'ตรง',
                data.is_mismatch ? 'stat_danger' : 'stat_ok'
              )}
              {this.renderStat('รายการเดินแต้ม', `${data.entry_count || 0} รายการ`)}
              {Number(data.unmatched_out || 0) > 0 &&
                this.renderStat(
                  'หักแต้มที่ไม่มีล็อตรองรับ',
                  formatPoint(data.unmatched_out),
                  'stat_danger'
                )}
            </div>

            {nextExpire && nextExpire.period && (
              <div className="next_box">
                <div className="next_title">
                  ล็อตถัดไปที่จะหมดอายุ: {nextExpire.period.key} (
                  {nextExpire.period.received_label})
                </div>
                <div className="next_desc">
                  หมดอายุ {nextExpire.period.expire_label} (อีก{' '}
                  {nextExpire.days_left} วัน) • คงเหลือในล็อต{' '}
                  {formatPoint(nextExpire.lot_remaining)} • ยอดที่จะถูกตัด{' '}
                  <b>{formatPoint(nextExpire.expiring_point)}</b>
                </div>
              </div>
            )}

            <div className="section">
              <div className="section_title">ยอดแยกตามล็อต</div>
              <div className="table_wrap">
                <table className="item_table">
                  <thead>
                    <tr>
                      <th>ล็อต</th>
                      <th className="right">ได้รับ</th>
                      <th className="right">ปรับเพิ่ม</th>
                      <th className="right">ใช้ไป</th>
                      <th className="right">ปรับลด</th>
                      <th className="right">ตัดหมดอายุแล้ว</th>
                      <th className="right">คงเหลือ</th>
                      <th>วันหมดอายุ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lots.length === 0 ? (
                      <tr>
                        <td colSpan={8} className="center">
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    ) : (
                      lots.map((e, i) => (
                        <tr key={i}>
                          <td>{RENDER_LOT_LABEL(e.key)}</td>
                          <td className="right">{formatPoint(e.received)}</td>
                          <td className="right">{formatPoint(e.adjusted_in)}</td>
                          <td className="right">{formatPoint(e.redeemed)}</td>
                          <td className="right">{formatPoint(e.adjusted_out)}</td>
                          <td className="right">{formatPoint(e.expired)}</td>
                          <td className="right bold">{formatPoint(e.remaining)}</td>
                          <td>{e.expire_at ? formatDate(e.expire_at) : 'ไม่หมดอายุ'}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="section">
              <div className="section_title">
                รายการเดินแต้ม{' '}
                {ledger.filter((e) => e.is_counted !== false).length} รายการ
                {ledger.some((e) => e.is_counted === false)
                  ? ` (ไม่นับ ${
                      ledger.filter((e) => e.is_counted === false).length
                    } รายการ)`
                  : ''}
              </div>
              <div className="table_wrap ledger_wrap">
                <table className="item_table">
                  <thead>
                    <tr>
                      <th>วันที่</th>
                      <th>รายการ</th>
                      <th className="right">แต้ม</th>
                      <th>ล็อต</th>
                      <th>หมายเหตุ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ledger.length === 0 ? (
                      <tr>
                        <td colSpan={5} className="center">
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    ) : (
                      // is_counted === false = แถว system error (4/6) ก่อน 1 ม.ค. 2569
                      // ที่ replay ไม่นับ แสดงเป็นสีเทาให้รู้ว่าไม่มีผลต่อยอด ledger
                      ledger.map((e, i) => {
                        const notCounted = e.is_counted === false;
                        return (
                          <tr key={i} className={notCounted ? 'not_counted' : ''}>
                            <td className="nowrap">{formatDateTime(e.created_at)}</td>
                            <td>{RENDER_LEDGER_ACTION(e)}</td>
                            <td
                              className={`right ${
                                notCounted
                                  ? ''
                                  : LEDGER_SIGNED_POINT(e) < 0
                                  ? 'minus'
                                  : 'plus'
                              }`}
                            >
                              {LEDGER_SIGNED_LABEL(e)}
                            </td>
                            <td>{RENDER_LOT_LABEL(e.expire_period)}</td>
                            <td className="remark">
                              {notCounted && (
                                <div className="not_counted_note">
                                  ไม่นับใน ledger (บันทึกประกอบปี 2566)
                                </div>
                              )}
                              {e.remark || (notCounted ? '' : '-')}
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {expireLogs.length > 0 && (
              <div className="section">
                <div className="section_title">ประวัติการตัดแต้มหมดอายุ</div>
                <div className="table_wrap">
                  <table className="item_table">
                    <thead>
                      <tr>
                        <th>วันที่ตัด</th>
                        <th>ล็อต</th>
                        <th className="right">ยอดที่ตัด</th>
                        <th className="right">Wallet ก่อน</th>
                        <th className="right">Wallet หลัง</th>
                        <th>สถานะ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {expireLogs.map((e, i) => (
                        <tr key={i}>
                          <td className="nowrap">
                            {formatDateTime(e.expired_run_at || e.created_at)}
                          </td>
                          <td>{e.period_key}</td>
                          <td className="right">{formatPoint(e.expired_point)}</td>
                          <td className="right">{formatPoint(e.wallet_point_before)}</td>
                          <td className="right">
                            {e.wallet_point_after === undefined ||
                            e.wallet_point_after === null
                              ? '-'
                              : formatPoint(e.wallet_point_after)}
                          </td>
                          <td>
                            <span className={`status_badge status_${e.status}`}>
                              {RENDER_LOG_STATUS(e.status)}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <div className="action_zone">
              <div className="btn_box">
                <Buttons.BgStandard theme_gray label="ปิด" onClick={onClose} />
              </div>
            </div>
          </>
        )}
      </CustomerPointBreakdownContainerStyled>
    );
  }
}

export default CustomerPointBreakdownContainer;
